import { lazy } from 'react';

const CharityVettingPreparationKitchenRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingPreparationKitchen" */ '../components/steps/preparation-kitchen-step/PreparationKitchen'
    ),
);

export default CharityVettingPreparationKitchenRoute;
